module.exports = __webpack_public_path__ + "img/04l-Shop_651.28493711.jpg";